import { FETCH_USERNAMES_INFO_SUCCESS } from "./types";
import { ProfileInfo } from "../reducers/ProfileReducers";
import { userNamesActionInterface } from "../reducers/UserNameReducers";
import { Dispatch } from "react";

export const setUserNameInfo = (user: ProfileInfo) => {
  return (dispatch: Dispatch<userNamesActionInterface>) => {
    dispatch({
      type: FETCH_USERNAMES_INFO_SUCCESS,
      payload: user
    });
  };
};
